// src/screens/admin/studyGroups/StudyGroups.js
import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Modal,
  Form,
  Table,
} from "react-bootstrap";
import AdminLayout from "../../../layouts/admin/adminlayout/AdminLayout";
import "../../../assets/css/admin/adminStudyGroups/AdminStudyGroups.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

const AdminStudyGroups = () => {
  const { baseUrl, loggedInAdmin } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [mentors, setMentors] = useState([]);
  const [groupname, setGroupName] = useState("");
  const [subject, setSubject] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [description, setDescription] = useState("");
  const [mentor, setMentor] = useState("");
  const [status, setStatus] = useState("");
  const [maxAllowMembers, setMaxAllowMembers] = useState(0);
  const [groups, setGroups] = useState([]);

  const createAdminStudyGroups = (mentor_id) => {
  
    const formData = new FormData();
    formData.append("id", mentor_id);
    formData.append("groupName", groupname);
    formData.append("subjectName", subject);
    formData.append("description", description);
    formData.append("chmentor_id", mentor);
    formData.append("chsubadmin_id", loggedInAdmin.id);//replace with stored ADMIN ID IN LOCAL STORAGE
    formData.append("maximumMembers", maxAllowMembers);
    formData.append("ispaid", true);
    formData.append("status", status);
    axios
      .post(`${baseUrl}/admin/studygroup/createStudyGroup`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        setShowModal(false);
        console.log(response.data);
        viewAllMentor();
        viewAllStudyGroups();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //viewAllMentors
  const viewAllMentor = () => {
    axios
      .post(`${baseUrl}/admin/mentor/viewAllMentor`)
      .then((response) => {
        console.log(response.data);
        setMentors(response.data.mentor);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllStudyGroups = () => {
    axios.post(`${baseUrl}/admin/studygroup/viewAllStudyGroups`).then((response) => {
      console.log(response.data);
      setGroups(response.data.studygroups);
    }).catch((error) => {
      console.log(error);
    });
  }

  const handleViewGroup = (group) => {
    setSelectedGroup(group);
    setShowViewModal(true);
  };

  const handleDeleteGroup = (id) => {
    if (window.confirm("Are you sure you want to delete this group?")) {
      setGroups(groups.filter((g) => g.id !== id));
    }
  };

  const handleArchiveGroup = (id) => {
    setGroups(
      groups.map((g) =>
        g.id === id
          ? { ...g, status: g.status === "active" ? "archived" : "active" }
          : g,
      ),
    );
  };

  const getActivityColor = (activity) => {
    switch (activity.toLowerCase()) {
      case "very high":
        return "primary";
      case "high":
        return "success";
      case "medium":
        return "warning";
      case "low":
        return "secondary";
      default:
        return "secondary";
    }
  };

  const viewAllSubjects = () => {
    axios
      .post(`${baseUrl}/admin/subject/viewAllSubjects`)
      .then((response) => {
        setSubjects(response.data.subjects);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllMentor();
    viewAllStudyGroups();
    viewAllSubjects();
  }, []);

  return (
    <AdminLayout>
      <div className="study-groups-page">
        {/* Page Header */}
        <div className="page-header mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="page-title">
                <span className="page-icon">👥</span>
                Study Groups Management
              </h2>
              <p className="text-muted">
                Manage all study groups and their members
              </p>
            </div>
            <Button
              variant="primary"
              size="lg"
              className="add-group-btn"
              onClick={() => {
                setShowModal(true);
                setGroupName("");
                setSubject("");
                setDescription("");
                setMentor("");
                setStatus("");
              }}
            >
              Create New Group
            </Button>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="mb-4">
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-purple">
              <Card.Body>
                <div className="stat-icon">📚</div>
                <div className="stat-info">
                  <h3>{groups.length}</h3>
                  <p>Total Groups</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-green">
              <Card.Body>
                <div className="stat-icon">✅</div>
                <div className="stat-info">
                  <h3>{groups.filter((g) => g.status === "active").length}</h3>
                  <p>Active Groups</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-blue">
              <Card.Body>
                <div className="stat-icon">👨‍🎓</div>
                <div className="stat-info">
                  <h3>{groups.reduce((sum, g) => sum + g.members, 0)}</h3>
                  <p>Total Members</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-orange">
              <Card.Body>
                <div className="stat-icon">👨‍🏫</div>
                <div className="stat-info">
                  <h3>{new Set(groups.map((g) => g.mentor)).size}</h3>
                  <p>Mentors</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Groups Grid */}
        <Row>
          {groups.map((group) => (
            <Col lg={4} md={6} key={group.id} className="mb-4">
              <Card className="group-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <h5 className="group-name">{group.groupName}</h5>
                      <Badge bg="info" className="subject-badge">
                        {group.subjectName}
                      </Badge>
                    </div>
                  </div>

                  <p className="group-description">{group.description.slice(0, 70)}...<span onClick={() => {
                    Swal.fire({
                      "title": "DETAILS",
                      "text": group.description
                    })
                  }} style={{ cursor: "pointer" }} className="text-success"><b>REAM MORE</b></span></p>

                  <div className="group-meta mb-3">
                    <div className="meta-item">
                      <i className="bi bi-people-fill"></i>
                      <span>{group.maximumMembers} Members</span>
                    </div>
                    <div className="meta-item">
                      <i className="bi bi-person-badge"></i>
                      <span>{group.chmentor?.name || "No Mentor Assigned"}</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <Badge
                      bg={group.status === "active" ? "success" : "secondary"}
                    >
                      {group.status}
                    </Badge>
                    <div className="group-actions">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => handleViewGroup(group)}
                      >
                        <i className="bi bi-eye"></i>
                      </Button>
                      <Button
                        variant="outline-warning"
                        size="sm"
                        onClick={() => handleArchiveGroup(group.id)}
                      >
                        <i className="bi bi-archive"></i>
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDeleteGroup(group.id)}
                      >
                        <i className="bi bi-trash"></i>
                      </Button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Create Group Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Create New Study Group</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Group Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter group name"
                      value={groupname}
                      onChange={(event) => { setGroupName(event.target.value) }} />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Select value={subject} onChange={(event) => { setSubject(event.target.value) }}>
                      {subjects.map((singleSubject) => {
                        return (
                          <option value={singleSubject.id}>
                            {singleSubject.name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Maximum Allowed Members</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Maximum Allow Members" value={maxAllowMembers} onChange={(event) => { setMaxAllowMembers(event.target.value) }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter group description" value={description} onChange={(event) => { setDescription(event.target.value) }}
                />
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mentor</Form.Label>
                    <Form.Select value={mentor} onChange={(event) => { setMentor(event.target.value) }}>
                      {mentors.map((singleMentor) => {
                        return (
                          <option value={singleMentor.id}>
                            {singleMentor.name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select value={status} onChange={(event) => { setStatus(event.target.value) }}>
                      <option value={"active"}>Active</option>
                      <option value={"deactive"}>Archived</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" >
              Cancel
            </Button>
            <Button onClick={() => createAdminStudyGroups()} variant="primary">Create Group</Button>
          </Modal.Footer>
        </Modal>

        {/* View Group Modal */}
        <Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Group Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedGroup && (
              <div className="group-details">
                <div className="mb-4">
                  <h4>{selectedGroup.groupName}</h4>
                  <div className="d-flex gap-2 mb-3">
                    <Badge bg="info">{selectedGroup.subjectName}</Badge>
                    <Badge
                      bg={
                        selectedGroup.status === "active"
                          ? "success"
                          : "secondary"
                      }
                    >
                      {selectedGroup.status}
                    </Badge>
                  </div>
                  <p>{selectedGroup.description}</p>
                </div>

                <Row className="mb-4">
                  <Col md={6}>
                    <p>
                      <strong>Members:</strong> {selectedGroup.maximumMembers}
                    </p>
                    <p>
                      <strong>Mentor:</strong> {selectedGroup.chmentor_id}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Created:</strong> {selectedGroup.created_at}
                    </p>
                  </Col>
                </Row>

                <h6>Recent Members</h6>
                <Table hover size="sm">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Joined</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>John Doe</td>
                      <td>2024-03-01</td>
                      <td>
                        <Badge bg="success">Active</Badge>
                      </td>
                    </tr>
                    <tr>
                      <td>Sarah Smith</td>
                      <td>2024-02-28</td>
                      <td>
                        <Badge bg="success">Active</Badge>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowViewModal(false)}>
              Close
            </Button>
            <Button variant="primary">Edit Group</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default AdminStudyGroups;
